import { QUARTER_TYPE } from "./get-quarter.types";

const QUARTERS: QUARTER_TYPE = {
  1: [0, 1, 2],
  2: [3, 4, 5],
  3: [6, 7, 8],
  4: [9, 10, 11],
};

export const getQuarter = (date: Date) => {
  const key = Math.floor(date.getMonth() / 3) + 1;
  return QUARTERS[key as keyof typeof QUARTERS];
};

export const getLastQuarterDates = (date: Date = new Date()) => {
  let lastQuarterIndex = Math.floor(date.getMonth() / 3);
  const yearChange = lastQuarterIndex === 0 ? 1 : 0;
  lastQuarterIndex = lastQuarterIndex === 0 ? 4 : lastQuarterIndex;
  const lastQuarter = QUARTERS[lastQuarterIndex as keyof typeof QUARTERS];

  const year = date.getFullYear() - yearChange;
  return {
    startDate: new Date(year, lastQuarter[0], 1),
    endDate: new Date(year, lastQuarter[2] + 1, 0),
  };
};

export const getCurrentQuarterDates = (date: Date = new Date()) => {
  const currentQuarter = getQuarter(date);
  const year = date.getFullYear();
  return {
    startDate: new Date(year, currentQuarter[0], 1),
    endDate: new Date(year, currentQuarter[2] + 1, 0),
  };
};
